if ($('.fadein').length) {
    var controller = new ScrollMagic.Controller();
    
    $('.fadein').each(function() {
        var $currentEl = $(this);

        new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 0.8
            })
            .on('start', function() {
                $currentEl.addClass('loaded');
            })
            .addTo(controller);
    });
}



// WEBPACK FOOTER //
// ./library/js/modules/fade-in-default.js